import { render, staticRenderFns } from "./Dealers.vue?vue&type=template&id=7caafc36&scoped=true"
import script from "./Dealers.vue?vue&type=script&lang=js"
export * from "./Dealers.vue?vue&type=script&lang=js"
import style0 from "./Dealers.vue?vue&type=style&index=0&id=7caafc36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caafc36",
  null
  
)

export default component.exports